const requestOptions = {
  get: {
    method: 'GET',
    cache: 'no-cache',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    redirect: 'error',
    referrer: 'no-referrer',
  },
  put: {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  },
  post: {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  },
  postFormData: {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Accept': 'application/json, text/plain, */*'
    },
  },
  putFormData: {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Accept': 'application/json, text/plain, */*'
    },
  },
  delete: {
    method: 'DELETE',
    credentials: 'include'
  }
};

export default requestOptions;
export const request = requestOptions